import React, { FC, useState, useEffect } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import {
    MessageBar,
    MessageBarType,
    Icon, DefaultButton, SpinnerSize, Spinner
} from '@fluentui/react';
import { useTranslation } from 'react-i18next';
import { TextField, Dialog, ApiException } from '@eta/components';
import { isNull } from 'util';
import { ReduxState } from '../../common/reducers';
import { otpVerifyUser, otpVerifyTaxpayer } from '../Redux/Actions';
import {
    LanguageTypes,
    ProfileType,
    ResendUserOTPRequest,
    ValidateTaxpayerOtpRequest,
    ValidationType,
} from '../../Services/ClientProxy/clientProxy';

import './Mobile.scss';
import { isEmptyText } from '../../helpers/utils';
import { validateContactDetails } from '../../ProviderManagement/Redux/Actions';
import { ContactTypes } from '../../ProviderManagement/Service/proxy';
import { ServiceCreator } from '../../Services/ClientProxy/ServiceFactory';
import { Defaults } from '../../common/config/constants';

const mapStateToProps = (state: ReduxState) => ({
    lastError: state.Verify.lastError,
});

const mapDispatchToProps = {
    verify: otpVerifyUser,
    verifyTaxpayer: otpVerifyTaxpayer,
    verifyIntermediaryOTP: validateContactDetails
};

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

export interface Props {
    NewMobile?: string;
    hidden: boolean;
    onClose: () => void;
    onSave: () => void;
    Type: string;
    verifyIntermediary?: boolean;
    taxpayerId?: number;
    preferredLanguage?: LanguageTypes | undefined;
}

const Mobile: FC<PropsFromRedux & Props> = (props: PropsFromRedux & Props) => {
    const { t } = useTranslation([
        'resources',
        'common',
        'myProfile',
        'validation',
    ]);

    const {
        NewMobile,
        hidden,
        onClose,
        verify,
        onSave,
        Type,
        verifyTaxpayer,
        lastError,
        verifyIntermediary,
        verifyIntermediaryOTP,
        taxpayerId,
        preferredLanguage
    } = props;

    const [mobileCode, setmobileCode] = useState<string>('');
    const [showMessageError, setmessageError] = useState<string>();
    const [isVerifying, setIsVerifying] = useState<boolean>(false);
    const [seconds, setSeconds] = useState<number>(Defaults.ResendOTP);

    useEffect(() => {
        if (lastError) {
            setmessageError(lastError?.serviceError?.toString());
        }
    }, [lastError]);

    const handleVerifyClick = async () => {
        setIsVerifying(true);
        let response;
        if (verifyIntermediary) {
            response = await verifyIntermediaryOTP(taxpayerId || 0, mobileCode, ContactTypes.Mobile);
        } else {
            const body = new ValidateTaxpayerOtpRequest({
                validationType: ValidationType.Mobile,
            });
            if (Type === 'User') {
                response = await verify(body, mobileCode);
            } else {
                response = await verifyTaxpayer(body, mobileCode);
            }
        }
        if (isNull((await response.payload).lastError))
            onSave();

        setIsVerifying(false);
    };

    const renderTimer = (time: number) => {
        let second = (time % 60).toString();
        let minute = (Math.floor(time / 60)).toString();
        minute = minute.toString().length === 1 ? `0${minute}` : minute.toString();
        second = second.toString().length === 1 ? `0${second}` : second.toString();
        return `${minute}:${second}`;
    };

    useEffect(() => {
        if (seconds > 0) {
            setTimeout(() => setSeconds(seconds - 1), 1000);
        }
    });


    useEffect(() => {
        if (!hidden) {
            setmobileCode('');
            setmessageError('');
        }
    }, [hidden]);

    const resendOTP = async () => {
        try {
            const client = ServiceCreator.getTaxPayerProfileManagementClient(false);
            const response = await client.resendUserOtp(
                new ResendUserOTPRequest({
                    preferredLanguage: preferredLanguage ?? LanguageTypes.None,
                    profileType: (Type === 'User') ? ProfileType.TaxpayerRepresentative : ProfileType.TaxPayer,
                    validationType: ValidationType.Mobile,
                })
            );
            if (response) {
                // setCompleted(true);
                setSeconds(Defaults.ResendOTP);
            }
        } catch (ex) {
            const exception = ex as ApiException;
            setmessageError(exception.serviceError?.toString());
        }
    };
    
    return (
        <Dialog
            hidden={hidden}
            onDismiss={() => {
                onClose();
            }}
            maxWidth={450}
            title={(
                <>
                    <Icon iconName="MobileSelected" /> {t('MobileVerification')}
                </>
            )}
        >
            <div className="contentMobail">
                {showMessageError && (
                    <div className="errorMessage">
                        <MessageBar
                            messageBarType={MessageBarType.error}
                            isMultiline={false}
                            onDismiss={() => setmessageError('')}

                        >
                            {showMessageError}
                        </MessageBar>
                    </div>
                )}
                <div className="code bodyLine">
                    <p className="headerMobail">
                        {t('form.verification.sentToMobile')}
                    </p>
                    <p>
                        <strong className='mobile_code'>{NewMobile}</strong>
                        <span>{t('form.verification.sentToMobile2')}</span>
                    </p>
                </div>
                <br />
                <div className="mobileCode bodyLine ClientDetails">
                    <TextField
                        maxLength={6}
                        autoFocus
                        onChange={(_, v) => setmobileCode(v ?? '')}
                        value={mobileCode}
                        placeholder={t('form.verification.verificationCode')}
                    />
                </div>
                <div className='resend'>
                        <span> {t('receive_SMS')} </span>
                        {seconds > 0 ? (
                            <div className='inline_Content'>
                                <span> {t('resend_code')} </span>
                                <span className='font_Timer'> {renderTimer(seconds)} </span>
                            </div>

                        ) : (
                                // eslint-disable-next-line jsx-a11y/anchor-is-valid
                                <a href={undefined} className='Link_Button' onClick={() => resendOTP()}> {t('resend')} </a>
                            )}
                    </div>
                <div className="verifystyle bodyLine doneBtn">
                    <DefaultButton
                        text={t('form.verification.verify')}
                        onClick={() => handleVerifyClick()}
                        disabled={isVerifying || isEmptyText(mobileCode)}
                    >
                        {isVerifying && <Spinner size={SpinnerSize.small}/>}
                        </DefaultButton>


                </div>
            </div>
        </Dialog>
    );
};

export default connector(Mobile);
